<ion-content class="cart-container">
  <ion-list-header class="cart-header">
    <ion-label class="cart-header__title">Items in cart</ion-label>
    <ion-button (click)="close()" class="cart-header__close-btn" fill="clear" color="dark">
      <svg slot="icon-only" class="cart-header__close-btn-icon" aria-label="Cart image">
        <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
      </svg>
    </ion-button>
  </ion-list-header>

  <hr *ngIf="showLoyaltyBanner" class="cart-container__line"/>
  <app-loyalty-banner *ngIf="showLoyaltyBanner" [withBorder]="true" [loyaltyBannerType]="loyaltyBannerType"></app-loyalty-banner>

  <app-cart-item *ngFor="let cartItem of menuItemsInCart; let first = first; index as i"
                 [item]="cartItem" border="top"
                 (delete)="deleteItemFromCart(i)"
                 [serviceChargeName]='restaurant?.serviceChargeName'
                 [displayKyooFee]="restaurant?.displayKyooFeeOnMenu && first">
  </app-cart-item>

  <ion-button (click)="goToCheckoutPage()"
              id="go-checkout"
              class="cart-item__checkout-button"
              expand="block" color="brand"
              [disabled]="cartStore.updateCartInProgress">
    <div class="cart-item__checkout-button-content-wrapper">
      <div slot="start" class="cart-item__checkout-button-content-wrapper-text">
        {{cartButtonText}}
      </div>
<!--      <div slot="end">${{ getFormattedPrice(calculateOrdersSum())}}</div>-->
    </div>
  </ion-button>
</ion-content>
